import { createAPIHeaders, fetchUtility } from '.';
import { MetricsFilters } from '../../types/admin';

export const createContainer = async (containerName: string, apiKey: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/azure/createContainer`, {
		headers: createAPIHeaders(apiKey, 'POST'),
		method: 'POST',
		body: JSON.stringify({
			containerName,
		}),
	});
};

export const createOperation = async (apiKey: string, operationName: string, operationDesc: string, users: string[]): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/users/createOperation`, {
		headers: createAPIHeaders(apiKey, 'POST'),
		method: 'POST',
		body: JSON.stringify({
			operationName,
			operationDesc,
			users,
		}),
	});
};

export const assignOperation = async (apiKey: string, operationName: string, users: string[]): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/users/assignOperation/${operationName}`, {
		headers: createAPIHeaders(apiKey, 'POST'),
		method: 'POST',
		body: JSON.stringify({
			users,
		}),
	});
};

export const registerKeyphraseFile = async (
	apiKey: string,
	pipeline: string,
	fileName: string,
	title: string,
	useCase: string,
	fileHash: string,
	origin: string,
	organisation?: string
): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/eks/registerKeywordFile`, {
		headers: createAPIHeaders(apiKey, 'POST'),
		method: 'POST',
		body: JSON.stringify({
			pipeline,
			fileName,
			title,
			useCase,
			fileHash,
			origin,
			organisation,
		}),
	});
};

export const postAssignOrgRole = async (
	apiKey: string,
	orgId: string,
	userId: string,
	orgRoleIds: string[],
	oldOrgRoleIds: string[]
): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/users/assignOrgRole`, {
		headers: createAPIHeaders(apiKey, 'POST'),
		method: 'POST',
		body: JSON.stringify({ orgId, userId, orgRoleIds, oldOrgRoleIds }),
	});
};

export const postInsertDuplicates = async (apiKey: string, batches: string[]): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/eks/insertDuplicates`, {
		headers: createAPIHeaders(apiKey, 'POST'),
		method: 'POST',
		body: JSON.stringify({ batches }),
	});
};

//eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
export const updateOrganisationCustomData = async (apiKey: string, orgId: string, newData: any): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/users/updateOrganisationCustomData/${orgId}`, {
		headers: createAPIHeaders(apiKey, 'POST'),
		method: 'POST',
		body: JSON.stringify({ newData }),
	});
};

export const postMail = async (apiKey: string, to: string, subject: string, content: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/mail/sendMail`, {
		headers: createAPIHeaders(apiKey, 'POST'),
		method: 'POST',
		body: JSON.stringify({ to, subject, content }),
	});
};

export const getUploadMetrics = async (apiKey: string, filters: MetricsFilters): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/users/getUploadMetrics`, {
		headers: createAPIHeaders(apiKey, 'POST'),
		method: 'POST',
		body: JSON.stringify({ filters }),
	});
};

export const getOperationMetrics = async (apiKey: string, filters: MetricsFilters): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/users/getOperationMetrics`, {
		headers: createAPIHeaders(apiKey, 'POST'),
		method: 'POST',
		body: JSON.stringify({ filters }),
	});
};
